import styles from "./todoList.module.css";
import { BiTrash } from "react-icons/bi";
import { unixToPersianDate } from "admin-panel/create-tours/helperFunctions";

const Todo = ({ todo, onDelete }) => {
  return (
    <div className={styles.container}>
      <div className={styles.todoContainer} key={todo.id}>
        <div>{unixToPersianDate(todo.stm)}</div>
        <div>{unixToPersianDate(todo.ftm)}</div>
        <div>{todo.user_tag_id.label}</div>
        <div>{todo.prepay}</div>

        <div>
          <button className={styles.btn} onClick={onDelete}>
            <BiTrash />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Todo;
